module.exports = function (bugout, session, cbs, hooks = {}) {

  // store the latest message index for every client
  var messageState = {}

  bugout.on('message', function (address, msg) {
    if (typeof hooks.onReceive === 'function') {
      hooks.onReceive(msg, address)
    }
    console.log('received message from', address, 'message', msg)
    var clientId = msg.cid
    var messageNumber = msg.mnr
    var connectionEpoch = msg.epoch || 0
    var client = messageState[clientId]
    
    var processMessage = false

    if (client) {
      if (client.epoch !== connectionEpoch) {
        client.epoch = connectionEpoch
        client.messageNumber = 0
      }

      if (client.messageNumber < messageNumber) {
        processMessage = true
        client.messageNumber = messageNumber
      }
    }
    // first time message
    else {
      processMessage = true
      messageState[clientId] = {
        id: clientId,
        messageNumber: messageNumber,
        epoch: connectionEpoch
      }
    }

    if (processMessage) {
      if (cbs[msg.type]) {
        cbs[msg.type](msg)
      } else {
        console.log('Unknown event with type: ', msg.type)
      }
    }
  })

  var messageNumber = 0
  var epoch = Date.now()

  return function (tag, data) {
    messageNumber++
    const payload = {
      cid: session.identity,
      epoch: epoch,
      mnr: messageNumber,
      type: tag,
      msg: data
    }
    if (typeof hooks.onSend === 'function') {
      hooks.onSend(payload)
    }
    bugout.send(payload)
  }

}
